import { render } from "./EditMerchantDialog.vue?vue&type=template&id=8ae79e70&scoped=true"
import script from "./EditMerchantDialog.vue?vue&type=script&lang=js"
export * from "./EditMerchantDialog.vue?vue&type=script&lang=js"

import "./EditMerchantDialog.vue?vue&type=style&index=0&id=8ae79e70&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ae79e70"]])

export default __exports__